<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.1667 5.00002H18.3333V6.66669H16.6667V17.5C16.6667 17.721 16.5789 17.933 16.4226 18.0893C16.2663 18.2456 16.0544 18.3334 15.8333 18.3334H4.16667C3.94566 18.3334 3.7337 18.2456 3.57742 18.0893C3.42114 17.933 3.33334 17.721 3.33334 17.5V6.66669H1.66667V5.00002H5.83334V2.50002C5.83334 2.27901 5.92114 2.06704 6.07742 1.91076C6.2337 1.75448 6.44566 1.66669 6.66667 1.66669H13.3333C13.5544 1.66669 13.7663 1.75448 13.9226 1.91076C14.0789 2.06704 14.1667 2.27901 14.1667 2.50002V5.00002ZM15 6.66669H5.00001V16.6667H15V6.66669ZM11.1783 11.6667L12.6517 13.14L11.4733 14.3184L10 12.845L8.52667 14.3184L7.34834 13.14L8.82167 11.6667L7.34834 10.1934L8.52667 9.01502L10 10.4884L11.4733 9.01502L12.6517 10.1934L11.1783 11.6667ZM7.50001 3.33335V5.00002H12.5V3.33335H7.50001Z"
            v-bind:fill="color" />
    </svg>
</template>
<script>
export default {
    props: ["color"]
}
</script>